import { TopicWithSummary } from "../../../imsdk/api/topic";
import log from "../../../imsdk/log";
import * as ImSdk from "../../../imsdk/api/index";
import { buildSingleTopicId } from "../../utils/helper";
import { Str_CreateFail, Str_GroupChat } from "../../language/string_res";
import { showToast } from "../../components/Toast";

type Callback = (topic: TopicWithSummary, isReplace: boolean) => void;

// 创建会话&发送消息
export function createChat(members: number[], callback: Callback, isReplace: boolean = false) {
    if (members.length === 0) {
        return;
    }
    if (members.length === 1) {
        // 单聊
        return toSingleChat(members[0], callback, isReplace).then(() => { });
    } else {
        //群聊
        return createNewChat(Str_GroupChat, members, callback, isReplace).then(() => { });
    }
}

// 跳转单聊
export async function toSingleChat(
    toUid: number,
    callback: Callback,
    isReplace: boolean = false
): Promise<void> {
    const im = ImSdk.getInstance();
    const tid = buildSingleTopicId(im.CurrentUid(), toUid);
    const r = await im.GetTopicDetail(tid, true);
    if (r.error) {
        // todo 错误提示
        log.error('创建会话失败', r.error);
        return;
    }
    if (r.topic) {
        log.info('会话已存在，直接唤出', r.topic.topic.tid);
        callback(r.topic, isReplace);
        return;
    }
    const members = [toUid];
    if (toUid !== im.CurrentUid()) {
        members.push(im.CurrentUid());
    }
    const r1 = await im.CreateTopic({
        name: '',
        type: 'single',
        members: members,
    });
    if (r1.error) {
        // todo 错误提示
    }
    if (r1.topic) {
        // 创建新会话后，需要获取完整的 topic 详情（包括 summary、users 等）
        const detailResult = await im.GetTopicDetail(r1.topic.tid, true);
        if (detailResult.error || !detailResult.topic) {
            log.error('创建会话后获取详情失败', detailResult.error);
            callback({ topic: r1.topic }, isReplace);
            return;
        }
        callback(detailResult.topic, isReplace);
        return;
    }
    // todo bug
}

// 创建群聊
export async function createNewChat(
    name: string, // 群名称
    members: number[], // 群成员
    callback: Callback,
    isReplace: boolean = false
) {
    const im = ImSdk.getInstance();
    if (!members.includes(im.CurrentUid())) {
        members.push(im.CurrentUid());
    }
    const r1 = await im.CreateTopic({
        name: name,
        type: 'group',
        members: members,
    });
    if (r1.error) {
        // todo 错误提示
        showToast(r1?.error.msg || Str_CreateFail)
    }
    if (r1.topic) {
        const res = await ImSdk.getInstance().GetTopicDetail(r1.topic.tid, true)
        if (res.topic && res.topic && res.topic.group && res.topic.users) {
            callback(res.topic, isReplace);
        } else {
            const res = await ImSdk.getInstance().GetGroupRemote(r1.topic.tid)
            callback({ topic: r1.topic, group: res.group, users: res.members }, isReplace);
        }

        return;
    }
    // todo bug
}
